import { create } from 'zustand';
import { WorkspacePreferenceResponse } from '../../services/preference/preferenceEndpoints.interface';
import { updateWorkspacePreference } from '../../services/preference/preferenceEndpoints';

interface PreferencesState {
  preferences: WorkspacePreferenceResponse | null;
  workspaceId: string | null;
  setPreferences: (preferences: WorkspacePreferenceResponse) => void;
  setWorkspaceId: (workspaceId: string) => void;
  updatePreferences: (preferences: Partial<WorkspacePreferenceResponse>) => Promise<void>;
}

const usePreferencesStore = create<PreferencesState>((set, get) => ({
  preferences: null,
  workspaceId: null,
  
  setPreferences: (preferences) => set({ preferences }),
  
  setWorkspaceId: (workspaceId) => set({ workspaceId }),
  
  updatePreferences: async (newPreferences) => {
    const { preferences, workspaceId } = get();
    
    if (!preferences || !workspaceId) {
      throw new Error('Cannot update preferences: Missing current preferences or workspace ID');
    }
    
    // Merge current preferences with new preferences
    const updatedPreferences = {
      ...preferences,
      ...newPreferences
    };
    
    // Update in store optimistically
    set({ preferences: updatedPreferences });
    
    try {
      // Update on the server
      const response = await updateWorkspacePreference({
        workspace_id: workspaceId,
        ...updatedPreferences
      });
      
      // Update with server response to ensure consistency
      set({ preferences: response.data });
      return await Promise.resolve();
    } catch (error) {
      // Revert to original state in case of error
      set({ preferences });
      return Promise.reject(error);
    }
  }
}));

export default usePreferencesStore;
